import { observer } from "mobx-react-lite";
import { useAppContext } from "../../../shared/functions/Context";
import ErrorBoundary from "../../../shared/components/error-boundary/ErrorBoundary";
import { useEffect, useState } from "react";
import { LoadingEllipsis } from "../../../shared/components/loading/Loading";
import ImportData from "./ImportData";
import { sortUserAlphabetically } from "./BonusReportFunctions";

export const BonusReport = observer(() => {
  const { store, api } = useAppContext();
  const [loading, setLoading] = useState(false);

  const users = store.user.all
    .filter((u) => u.asJson.userStatus === "Active" || !u.asJson.userStatus)
    .map((u) => {
      return u.asJson;
    })
    .sort(sortUserAlphabetically);

    console.log("Users: ", users);
    

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        await Promise.all([
          api.user.getAll(),
          api.companyScorecardMetadata.getAll(),
          api.objective.getAll(),
          api.scorecard.getAll(),
          api.measure.getAll(),
          api.department.getAll(),
        ]);
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  return (
    <ErrorBoundary>
      <div className="reports uk-section">
        <div className="uk-container uk-container-xlarge">
          <div className="objectives-card uk-card uk-card-default uk-card-body uk-card-small">
            {loading ? (
              <LoadingEllipsis />
            ) : (
              <div className="uk-margin">
                <div>
                  <ImportData users={users} />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
});
